import React from "react";
import BirpStatusBadge from "./BirpStatusBadge";
import { formatDateUS } from "@/lib/dates";

const formatDate = formatDateUS;

const BirpReportListItem = ({ report, active, onSelect }) => {
    const hasPeriod =
        report.period_end && report.period_end !== report.report_date;
    const dateLabel = hasPeriod
        ? `${formatDate(report.report_date)} → ${formatDate(report.period_end)}`
        : formatDate(report.report_date);
    return (
        <button
            type="button"
            onClick={() => onSelect(report)}
            data-testid={`birp-report-item-${report.id}`}
            data-active={active || undefined}
            className={`group w-full rounded-xl border p-3 text-left transition-colors ${
                active
                    ? "border-brand-blue-500 bg-brand-blue-50/70 shadow-[0_2px_10px_rgba(30,64,175,0.08)]"
                    : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"
            }`}
        >
            <div className="flex items-start justify-between gap-2">
                <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-bold text-slate-900">
                        {report.individual_name}
                    </p>
                    <p
                        className="mt-0.5 truncate text-[11px] font-semibold uppercase tracking-widest text-slate-400"
                        data-testid={`birp-report-period-${report.id}`}
                    >
                        {dateLabel}
                    </p>
                </div>
                <BirpStatusBadge status={report.status} />
            </div>
            <div className="mt-2 flex items-center justify-between text-[11px] text-slate-500">
                <span>
                    {report.measurement_count ?? 0}{" "}
                    {report.measurement_count === 1
                        ? "measurement"
                        : "measurements"}
                    {hasPeriod && (
                        <span className="ml-1.5 rounded-full bg-brand-blue-100 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-brand-blue-800">
                            Period
                        </span>
                    )}
                </span>
                {report.model_used && (
                    <span className="truncate font-mono text-[10px] text-slate-400">
                        {report.model_used.split("-").slice(0, 3).join("-")}
                    </span>
                )}
            </div>
        </button>
    );
};

export default BirpReportListItem;
